var _feGaussianBlur, _feGaussianBlur2, _feGaussianBlur3, _feGaussianBlur4, _feGaussianBlur5, _feGaussianBlur6, _feGaussianBlur7, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackendSystem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000.903,
    height: 702.513,
    viewBox: "0 0 529.406 185.873",
    xmlSpace: "preserve",
    id: "svg127",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  }, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "a",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur1"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "b",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur2"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "c",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur3"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "d",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur4"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "e",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur5"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "f",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur6"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "g",
    x: -0.018243244,
    y: -0.0041144426,
    width: 1.0364865,
    height: 1.0082289
  }, _feGaussianBlur7 || (_feGaussianBlur7 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.045,
    id: "feGaussianBlur7"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#3a96b8",
      fillOpacity: 1,
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "m524.445-157.92 18.428-10.665v-7.109l-4.446-3.164-39.707-11.803-.374 17.68z",
    transform: "translate(-53.76 341.577)",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#274b78",
      fillOpacity: 1,
      strokeWidth: 0.801532,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m224.506-59.819 17.572 10.428 19.472-11.837-16.907-10.24z",
    transform: "matrix(.58947 0 0 .65363 -71.67 138.898)",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#20366a",
      fillOpacity: 1,
      strokeWidth: 0.801532,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m224.434-8.712 17.485 10.575.16-51.254-17.573-10.428z",
    transform: "matrix(.58947 0 0 .65363 -71.67 138.898)",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#2c6193",
      fillOpacity: 1,
      strokeWidth: 0.801532,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M261.323-10.032 241.92 1.863l.16-51.254 19.471-11.837z",
    transform: "matrix(.58947 0 0 .65363 -71.67 138.898)",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#327c97",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M243.97-40.549v5.098l15.459-9.167.07-5.355zm0-6.515v5.099l15.459-9.168.07-5.355zm0 13.03v5.098l15.459-9.167.07-5.356zm0 6.514v5.099l15.459-9.167.07-5.356zm0 6.516v5.098l15.459-9.168.07-5.355zm0 6.514v5.099l15.459-9.168.07-5.355zm0 6.515v5.098l15.459-9.167.07-5.355z",
    transform: "matrix(.58947 0 0 .65363 -71.67 138.898)",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#1b496b",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m238.682-38.33-.047 6.642-10.781-6.361-.024-6.9zm-.024 17.817.047 3.616-10.781-6.36-.117-3.345z",
    transform: "matrix(.58947 0 0 .65363 -71.67 138.898)",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#243764",
      fillOpacity: 1,
      strokeWidth: 1.04041,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m254.862-62.522-9.261-5.781-14.391 9.03 8.933 5.659z",
    transform: "matrix(.58947 0 0 .65363 -71.67 138.898)",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#275d82",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m251.745-62.35-6.688-4.101-10.98 6.89 6.26 3.988z",
    transform: "matrix(.58947 0 0 .65363 -71.67 138.898)",
    id: "path14"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.93243 0 0 1.37128 106.805 57.521)",
    id: "g14"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(.93243 0 0 1.37128 -34.149 -227.517)",
    id: "g15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.136-5.44c-6.772 0-12.262 2.626-12.262 5.865v15.994c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864V.425c0-3.24-5.49-5.865-12.262-5.865",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(.93243 0 0 1.37128 106.805 57.521)",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d6d83",
      fillOpacity: 1,
      strokeWidth: 0.701962,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M63.027-4.202v25.296s6.454-1.66 6.593-3.568c.648-8.901.657-8.826 0-18.526-.125-1.834-6.593-3.202-6.593-3.202",
    transform: "matrix(.93243 0 0 1.37128 106.805 57.521)",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#258faa",
      fillOpacity: 1,
      strokeWidth: 0.712917,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers",
      filter: "url(#a)"
    },
    d: "M63.503-4.54v26.092h-5.92V-4.697z",
    transform: "matrix(.93243 0 0 1.37128 106.805 57.521)",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 0.861586,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M69.569.526A11.134 5.073 0 0 1 58.31 5.522 11.134 5.073 0 0 1 47.303.41a11.134 5.073 0 0 1 11.175-5.035A11.134 5.073 0 0 1 69.57.45",
    transform: "matrix(.93243 0 0 1.37128 106.805 57.521)",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.136-5.44c-6.772 0-12.262 2.626-12.262 5.865v15.994c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864V.425c0-3.24-5.49-5.865-12.262-5.865m0 1.066c6.597 0 11.196 2.529 11.196 4.799 0 2.269-4.598 4.798-11.196 4.798S46.94 2.693 46.94.425c0-2.27 4.597-4.8 11.196-4.8m11.196 19.726v1.066c0 2.269-4.598 4.798-11.196 4.798s-11.196-2.53-11.196-4.798v-1.683c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473v.616zm0-4.265c0 2.269-4.598 4.798-11.196 4.798s-11.196-2.53-11.196-4.798V9.472c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473zm0-5.331c0 2.269-4.598 4.798-11.196 4.798S46.94 8.024 46.94 5.756V4.27c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.93243 0 0 1.37128 106.805 57.521)",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.661286,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M67.399.405a9.15 3.637 0 0 1-9.252 3.581A9.15 3.637 0 0 1 49.102.322a9.15 3.637 0 0 1 9.183-3.609A9.15 3.637 0 0 1 67.4.35",
    transform: "matrix(.93243 0 0 1.37128 106.805 57.521)",
    id: "path20"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.93243 0 0 1.37128 125.616 69.014)",
    id: "g20"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(.93243 0 0 1.37128 -15.338 -216.024)",
    id: "g21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.136-5.44c-6.772 0-12.262 2.626-12.262 5.865v15.994c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864V.425c0-3.24-5.49-5.865-12.262-5.865",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(.93243 0 0 1.37128 125.616 69.014)",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d6d83",
      fillOpacity: 1,
      strokeWidth: 0.701962,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M63.027-4.202v25.296s6.454-1.66 6.593-3.568c.648-8.901.657-8.826 0-18.526-.125-1.834-6.593-3.202-6.593-3.202",
    transform: "matrix(.93243 0 0 1.37128 125.616 69.014)",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#258faa",
      fillOpacity: 1,
      strokeWidth: 0.712917,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers",
      filter: "url(#b)"
    },
    d: "M63.503-4.54v26.092h-5.92V-4.697z",
    transform: "matrix(.93243 0 0 1.37128 125.616 69.014)",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 0.861586,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M69.569.526A11.134 5.073 0 0 1 58.31 5.522 11.134 5.073 0 0 1 47.303.41a11.134 5.073 0 0 1 11.175-5.035A11.134 5.073 0 0 1 69.57.45",
    transform: "matrix(.93243 0 0 1.37128 125.616 69.014)",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.136-5.44c-6.772 0-12.262 2.626-12.262 5.865v15.994c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864V.425c0-3.24-5.49-5.865-12.262-5.865m0 1.066c6.597 0 11.196 2.529 11.196 4.799 0 2.269-4.598 4.798-11.196 4.798S46.94 2.693 46.94.425c0-2.27 4.597-4.8 11.196-4.8m11.196 19.726v1.066c0 2.269-4.598 4.798-11.196 4.798s-11.196-2.53-11.196-4.798v-1.683c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473v.616zm0-4.265c0 2.269-4.598 4.798-11.196 4.798s-11.196-2.53-11.196-4.798V9.472c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473zm0-5.331c0 2.269-4.598 4.798-11.196 4.798S46.94 8.024 46.94 5.756V4.27c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.93243 0 0 1.37128 125.616 69.014)",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.661286,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M67.399.405a9.15 3.637 0 0 1-9.252 3.581A9.15 3.637 0 0 1 49.102.322a9.15 3.637 0 0 1 9.183-3.609A9.15 3.637 0 0 1 67.4.35",
    transform: "matrix(.93243 0 0 1.37128 125.616 69.014)",
    id: "path26"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.93243 0 0 1.37128 87.992 69.425)",
    id: "g26"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(.93243 0 0 1.37128 -52.962 -215.613)",
    id: "g27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.136-5.44c-6.772 0-12.262 2.626-12.262 5.865v15.994c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864V.425c0-3.24-5.49-5.865-12.262-5.865",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(.93243 0 0 1.37128 87.992 69.425)",
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d6d83",
      fillOpacity: 1,
      strokeWidth: 0.701962,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M63.027-4.202v25.296s6.454-1.66 6.593-3.568c.648-8.901.657-8.826 0-18.526-.125-1.834-6.593-3.202-6.593-3.202",
    transform: "matrix(.93243 0 0 1.37128 87.992 69.425)",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#258faa",
      fillOpacity: 1,
      strokeWidth: 0.712917,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers",
      filter: "url(#c)"
    },
    d: "M63.503-4.54v26.092h-5.92V-4.697z",
    transform: "matrix(.93243 0 0 1.37128 87.992 69.425)",
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 0.861586,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M69.569.526A11.134 5.073 0 0 1 58.31 5.522 11.134 5.073 0 0 1 47.303.41a11.134 5.073 0 0 1 11.175-5.035A11.134 5.073 0 0 1 69.57.45",
    transform: "matrix(.93243 0 0 1.37128 87.992 69.425)",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.136-5.44c-6.772 0-12.262 2.626-12.262 5.865v15.994c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864V.425c0-3.24-5.49-5.865-12.262-5.865m0 1.066c6.597 0 11.196 2.529 11.196 4.799 0 2.269-4.598 4.798-11.196 4.798S46.94 2.693 46.94.425c0-2.27 4.597-4.8 11.196-4.8m11.196 19.726v1.066c0 2.269-4.598 4.798-11.196 4.798s-11.196-2.53-11.196-4.798v-1.683c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473v.616zm0-4.265c0 2.269-4.598 4.798-11.196 4.798s-11.196-2.53-11.196-4.798V9.472c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473zm0-5.331c0 2.269-4.598 4.798-11.196 4.798S46.94 8.024 46.94 5.756V4.27c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.93243 0 0 1.37128 87.992 69.425)",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.661286,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M67.399.405a9.15 3.637 0 0 1-9.252 3.581A9.15 3.637 0 0 1 49.102.322a9.15 3.637 0 0 1 9.183-3.609A9.15 3.637 0 0 1 67.4.35",
    transform: "matrix(.93243 0 0 1.37128 87.992 69.425)",
    id: "path32"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.93243 0 0 1.37128 106.977 80.51)",
    id: "g32"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(.93243 0 0 1.37128 -33.977 -204.528)",
    id: "g33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.136-5.44c-6.772 0-12.262 2.626-12.262 5.865v15.994c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864V.425c0-3.24-5.49-5.865-12.262-5.865",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(.93243 0 0 1.37128 106.977 80.51)",
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d6d83",
      fillOpacity: 1,
      strokeWidth: 0.701962,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M63.027-4.202v25.296s6.454-1.66 6.593-3.568c.648-8.901.657-8.826 0-18.526-.125-1.834-6.593-3.202-6.593-3.202",
    transform: "matrix(.93243 0 0 1.37128 106.977 80.51)",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#258faa",
      fillOpacity: 1,
      strokeWidth: 0.712917,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers",
      filter: "url(#d)"
    },
    d: "M63.503-4.54v26.092h-5.92V-4.697z",
    transform: "matrix(.93243 0 0 1.37128 106.977 80.51)",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 0.861586,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M69.569.526A11.134 5.073 0 0 1 58.31 5.522 11.134 5.073 0 0 1 47.303.41a11.134 5.073 0 0 1 11.175-5.035A11.134 5.073 0 0 1 69.57.45",
    transform: "matrix(.93243 0 0 1.37128 106.977 80.51)",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.136-5.44c-6.772 0-12.262 2.626-12.262 5.865v15.994c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864V.425c0-3.24-5.49-5.865-12.262-5.865m0 1.066c6.597 0 11.196 2.529 11.196 4.799 0 2.269-4.598 4.798-11.196 4.798S46.94 2.693 46.94.425c0-2.27 4.597-4.8 11.196-4.8m11.196 19.726v1.066c0 2.269-4.598 4.798-11.196 4.798s-11.196-2.53-11.196-4.798v-1.683c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473v.616zm0-4.265c0 2.269-4.598 4.798-11.196 4.798s-11.196-2.53-11.196-4.798V9.472c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473zm0-5.331c0 2.269-4.598 4.798-11.196 4.798S46.94 8.024 46.94 5.756V4.27c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.93243 0 0 1.37128 106.977 80.51)",
    id: "path37"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.661286,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M67.399.405a9.15 3.637 0 0 1-9.252 3.581A9.15 3.637 0 0 1 49.102.322a9.15 3.637 0 0 1 9.183-3.609A9.15 3.637 0 0 1 67.4.35",
    transform: "matrix(.93243 0 0 1.37128 106.977 80.51)",
    id: "path38"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.39967 0 0 2.05843 -111.597 83.113)",
    id: "g38"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(1.39967 0 0 2.05843 -323.183 -344.758)",
    id: "g39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.038 6.647c-6.772 0-12.262 2.626-12.262 5.865v4.836c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864v-4.836c0-3.24-5.49-5.865-12.262-5.865",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(1.39967 0 0 2.05843 -111.597 83.113)",
    id: "path39"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 0.861586,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M103.47 12.613a11.134 5.073 0 0 1-11.258 4.996 11.134 5.073 0 0 1-11.007-5.11A11.134 5.073 0 0 1 92.38 7.463a11.134 5.073 0 0 1 11.092 5.073",
    transform: "matrix(1.39967 0 0 2.05843 -111.597 83.113)",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.038 6.647c-6.772 0-12.262 2.626-12.262 5.865v10.427c-.049-.637 24.524 4.478 24.524-10.427 0-3.239-5.49-5.865-12.262-5.865m0 1.066c6.597 0 11.196 2.529 11.196 4.799 0 2.269-4.598 4.798-11.196 4.798s-11.196-2.529-11.196-4.798 4.597-4.799 11.196-4.799m-11.196 10.13v-1.485c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473c-4.98 11.445-22.392 6.12-22.392 1.485",
    style: {
      fill: "#fff"
    },
    transform: "matrix(1.39967 0 0 2.05843 -111.597 83.113)",
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.661286,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M101.3 12.492a9.15 3.637 0 0 1-9.251 3.581 9.15 3.637 0 0 1-9.045-3.664A9.15 3.637 0 0 1 92.187 8.8a9.15 3.637 0 0 1 9.115 3.637",
    transform: "matrix(1.39967 0 0 2.05843 -111.597 83.113)",
    id: "path42"
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0432 0 0 1.53419 354.332 137.733)",
    id: "g42"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(1.0432 0 0 1.53419 196.633 -181.168)",
    id: "g43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.136-5.44c-6.772 0-12.262 2.626-12.262 5.865v15.994c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864V.425c0-3.24-5.49-5.865-12.262-5.865",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(1.0432 0 0 1.53419 354.332 137.733)",
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d6d83",
      fillOpacity: 1,
      strokeWidth: 0.701962,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M63.027-4.202v25.296s6.454-1.66 6.593-3.568c.648-8.901.657-8.826 0-18.526-.125-1.834-6.593-3.202-6.593-3.202",
    transform: "matrix(1.0432 0 0 1.53419 354.332 137.733)",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#258faa",
      fillOpacity: 1,
      strokeWidth: 0.712917,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers",
      filter: "url(#e)"
    },
    d: "M63.503-4.54v26.092h-5.92V-4.697z",
    transform: "matrix(1.0432 0 0 1.53419 354.332 137.733)",
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 0.861586,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M69.569.526A11.134 5.073 0 0 1 58.31 5.522 11.134 5.073 0 0 1 47.303.41a11.134 5.073 0 0 1 11.175-5.035A11.134 5.073 0 0 1 69.57.45",
    transform: "matrix(1.0432 0 0 1.53419 354.332 137.733)",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.136-5.44c-6.772 0-12.262 2.626-12.262 5.865v15.994c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864V.425c0-3.24-5.49-5.865-12.262-5.865m0 1.066c6.597 0 11.196 2.529 11.196 4.799 0 2.269-4.598 4.798-11.196 4.798S46.94 2.693 46.94.425c0-2.27 4.597-4.8 11.196-4.8m11.196 19.726v1.066c0 2.269-4.598 4.798-11.196 4.798s-11.196-2.53-11.196-4.798v-1.683c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473v.616zm0-4.265c0 2.269-4.598 4.798-11.196 4.798s-11.196-2.53-11.196-4.798V9.472c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473zm0-5.331c0 2.269-4.598 4.798-11.196 4.798S46.94 8.024 46.94 5.756V4.27c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(1.0432 0 0 1.53419 354.332 137.733)",
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.661286,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M67.399.405a9.15 3.637 0 0 1-9.252 3.581A9.15 3.637 0 0 1 49.102.322a9.15 3.637 0 0 1 9.183-3.609A9.15 3.637 0 0 1 67.4.35",
    transform: "matrix(1.0432 0 0 1.53419 354.332 137.733)",
    id: "path48"
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.011 -.0038 .00205 .69433 440.65 178.36)",
    id: "g48"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(1.011 -.0038 .00205 .69433 287.392 34.608)",
    id: "g49"
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.93243 0 0 1.37128 462.667 73.068)",
    id: "g54"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(.93243 0 0 1.37128 321.713 -211.97)",
    id: "g55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.136-5.44c-6.772 0-12.262 2.626-12.262 5.865v15.994c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864V.425c0-3.24-5.49-5.865-12.262-5.865",
    style: {
      fill: "#3db3d4",
      fillOpacity: 1
    },
    transform: "matrix(.93243 0 0 1.37128 462.667 73.068)",
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d6d83",
      fillOpacity: 1,
      strokeWidth: 0.701962,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M63.027-4.202v25.296s6.454-1.66 6.593-3.568c.648-8.901.657-8.826 0-18.526-.125-1.834-6.593-3.202-6.593-3.202",
    transform: "matrix(.93243 0 0 1.37128 462.667 73.068)",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal",
      fill: "#258faa",
      fillOpacity: 1,
      strokeWidth: 0.712917,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers",
      filter: "url(#g)"
    },
    d: "M63.503-4.54v26.092h-5.92V-4.697z",
    transform: "matrix(.93243 0 0 1.37128 462.667 73.068)",
    id: "path57"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42afbf",
      fillOpacity: 1,
      strokeWidth: 0.861586,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M69.569.526A11.134 5.073 0 0 1 58.31 5.522 11.134 5.073 0 0 1 47.303.41a11.134 5.073 0 0 1 11.175-5.035A11.134 5.073 0 0 1 69.57.45",
    transform: "matrix(.93243 0 0 1.37128 462.667 73.068)",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.136-5.44c-6.772 0-12.262 2.626-12.262 5.865v15.994c0 3.238 5.49 5.864 12.262 5.864 6.771 0 12.262-2.626 12.262-5.864V.425c0-3.24-5.49-5.865-12.262-5.865m0 1.066c6.597 0 11.196 2.529 11.196 4.799 0 2.269-4.598 4.798-11.196 4.798S46.94 2.693 46.94.425c0-2.27 4.597-4.8 11.196-4.8m11.196 19.726v1.066c0 2.269-4.598 4.798-11.196 4.798s-11.196-2.53-11.196-4.798v-1.683c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473v.616zm0-4.265c0 2.269-4.598 4.798-11.196 4.798s-11.196-2.53-11.196-4.798V9.472c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473zm0-5.331c0 2.269-4.598 4.798-11.196 4.798S46.94 8.024 46.94 5.756V4.27c1.914 2.046 6.205 3.473 11.196 3.473s9.282-1.427 11.196-3.473z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.93243 0 0 1.37128 462.667 73.068)",
    id: "path59"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.661286,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M67.399.405a9.15 3.637 0 0 1-9.252 3.581A9.15 3.637 0 0 1 49.102.322a9.15 3.637 0 0 1 9.183-3.609A9.15 3.637 0 0 1 67.4.35",
    transform: "matrix(.93243 0 0 1.37128 462.667 73.068)",
    id: "path60"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(362.136 177.337)",
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47c0d3",
      fillOpacity: 1,
      strokeWidth: 0.591942,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-.16-82.687 30.97 17.513c1.67.945 2.128 3.877.489 4.874L18.3-52.394c-1.64.997-3.215 1.453-4.874.49l-30.362-17.644c-1.659-.964-2.114-3.854-.489-4.874l12.39-7.776c1.626-1.02 3.204-1.434 4.874-.49",
    id: "path61"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2990ce",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M.118-82.81-18.89-71.047l-.972-2.227 17.5-10.852z",
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      strokeWidth: 0.650192,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M-2.394-84.335c-1.113-.021-2.21.422-3.326 1.123l-13.61 8.54c-1.784 1.121-1.285 4.295.538 5.354l33.35 19.38c1.822 1.06 3.614.653 5.353-.537l13.255-9.074c1.74-1.19 1.293-4.308-.538-5.353L-.366-83.75c-.686-.392-1.36-.572-2.028-.585m.388 1.115c.608.012 1.22.176 1.846.533l30.88 17.469c1.667.952 2.074 3.79.49 4.874l-12.91 7.95c-1.583 1.084-3.215 1.453-4.874.49l-30.362-17.644c-1.659-.964-2.114-3.854-.489-4.874l12.39-7.776c1.016-.638 2.016-1.041 3.029-1.022",
    id: "path63"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      strokeWidth: 0.641011,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    width: 3.681,
    height: 0.665,
    x: -45.319,
    y: -51.501,
    ry: 0.333,
    transform: "rotate(29.987)",
    id: "rect63"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#333",
      fillOpacity: 1,
      strokeWidth: 0.445322,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    width: 2.558,
    height: 0.462,
    x: 32.008,
    y: -72.89,
    ry: 0.231,
    transform: "rotate(-32.547)",
    id: "rect64"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27315d",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m190.632-181.387.355-5.943 14.549 9.048-.09 5.589z",
    transform: "translate(-53.76 341.577)",
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f4e7a",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m190.987-187.33 24.04-14.282 14.46 8.516-23.951 14.814z",
    transform: "translate(-53.76 341.577)",
    id: "path65"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f7b9d",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m205.536-178.282-.09 5.589 24.104-15.556-.063-4.847z",
    transform: "translate(-53.76 341.577)",
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394270",
      fillOpacity: 1,
      strokeWidth: 0.31512,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m219.243-185.875.03 3.409 9.57-6.176-.092-3.115z",
    transform: "translate(-53.76 341.577)",
    id: "path67"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27315d",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-98.69 206.228.355-5.944 14.549 9.049-.09 5.588z",
    transform: "translate(192.34 -49.889)",
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f4e7a",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-98.335 200.284 18.521-10.634 14.46 8.516-18.432 11.167z",
    transform: "translate(192.34 -49.889)",
    id: "path69"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f7b9d",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-83.786 209.333-.09 5.588 18.585-11.907-.063-4.848z",
    transform: "translate(192.34 -49.889)",
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394270",
      fillOpacity: 1,
      strokeWidth: 0.31512,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-70.08 201.74.032 3.409 4.05-2.528-.092-3.115z",
    transform: "translate(192.34 -49.889)",
    id: "path71"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27315d",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-98.69 206.228.355-5.944 14.549 9.049-.09 5.588z",
    transform: "translate(274.059 -69.53)",
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f4e7a",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-98.335 200.284 18.521-10.634 14.46 8.516-18.432 11.167z",
    transform: "translate(274.059 -69.53)",
    id: "path73"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f7b9d",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-83.786 209.333-.09 5.588 18.585-11.907-.063-4.848z",
    transform: "translate(274.059 -69.53)",
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394270",
      fillOpacity: 1,
      strokeWidth: 0.31512,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-70.08 201.74.032 3.409 4.05-2.528-.092-3.115z",
    transform: "translate(274.059 -69.53)",
    id: "path75"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27315d",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 447.07299,124.65863 -0.355,-5.944 -14.549,9.049 0.09,5.588 z",
    id: "path72-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f4e7a",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 446.71799,118.71462 -18.521,-10.634 -14.46,8.516 18.432,11.167 z",
    id: "path73-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f7b9d",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 432.16899,127.76362 0.09,5.588 -18.585,-11.907 0.063,-4.848 z",
    id: "path74-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394270",
      fillOpacity: 1,
      strokeWidth: 0.31512,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 418.46299,120.17063 -0.032,3.409 -4.05,-2.528 0.092,-3.115 z",
    id: "path75-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27315d",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-99.616 205.17.355-5.944 15.475 10.107-.09 5.588z",
    transform: "translate(159.494 -29.048)",
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f4e7a",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-99.26 199.226 18.52-10.634 15.386 9.574-18.432 11.167z",
    transform: "translate(159.494 -29.048)",
    id: "path77"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f7b9d",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-83.786 209.333-.09 5.588 18.585-11.907-.063-4.848z",
    transform: "translate(159.494 -29.048)",
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394270",
      fillOpacity: 1,
      strokeWidth: 0.31512,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-70.08 201.74.032 3.409 4.05-2.528-.092-3.115z",
    transform: "translate(159.494 -29.048)",
    id: "path79"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1
    },
    id: "g80",
    transform: "translate(2.6499744,-1.472208)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.683903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m -17.938,-65.29 c -8.134,-0.038 -20.642,16.132 -18.38,25.52 -4.87,-0.518 -11.297,13.254 -14.814,19.217 -0.823,1.396 7.96,10.044 12.108,10.06 2.831,0.04 44.292,-27.326 44.292,-27.326 4.503,-3.767 5.545,-7.984 4.757,-13.263 -1.165,-3.904 -6.972,-5.608 -9.419,-4.287 -0.848,-5.861 -7.007,-2.033 -9.343,-0.465 0.342,-5.64 -4.356,-9.435 -9.201,-9.457",
    transform: "matrix(1.18102,0,0,1.218,118.4,98.372)",
    id: "path80"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 122.50797,30.954792 c 0,0 1.323,-0.897 2.09,-1.116 0.823,-0.237 2.68,-0.253 2.68,-0.253 0,0 -10.905,-6.996 -16.23,-9.658 -1.08,-0.54 -3.624,-0.14 -3.624,-0.14 0,0 -2.457,-2.153 -4.014,-2.72 -1.174,-0.428 -5.393996,-0.13 -5.393996,-0.13 1.07,2.434 9.162996,3.744 11.610996,7.955 0.427,1.245 1.094,4.829 1.094,4.829 0,0 5.66,-3.294 8.447,-2.47 1.677,0.494 3.34,3.702 3.34,3.702",
    id: "path81"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1,
      strokeWidth: 0.683903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 101.39397,23.392792 c -5.641996,-0.025 -17.939996,12.42 -16.952996,26.237 0.028,0.404 0.083,0.757 0.158,1.07 a 4,4 0 0 0 -0.38,-0.026 c -5.213,-0.024 -15.195,12.856 -15.234,19.14 -0.04,6.284 1.014,11.022 6.227,11.093 2.831,0.039 49.387996,-30.042 49.387996,-30.042 4.503,-3.767 5.546,-7.984 4.757,-13.263 -1.837,-6.945 -6.188,-4.413 -8.634,-3.092 -0.96,-9.011 -8.576,-3.554 -12.144,-0.249 1.014,-7.92 -2.34,-10.846 -7.185,-10.868",
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#bcddea",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 106.23397,21.702792 c 2.138,0.971 -19.327996,-11.412 -19.769996,-11.38 -9.002,0.664 -27.226,25.446 -18.848,32.713 0,0 12.895,5.018 13.052,3.845 1.615,-13.185 13.342,-30.735 25.565996,-25.178",
    id: "path83"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#accfe3",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m 80.559974,46.981792 -12.915,-7.667 c -0.416,-0.247 -1.605,-0.927 -2.047,-0.968 -7.972,-0.74 -21.626,27.293 -11.612,33.578 0,0 15.687,10.707 15.114,9.36 -8.87,-20.877 11.46,-34.303 11.46,-34.303",
    id: "path84"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1
    },
    id: "g85"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.683903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M-17.938-65.29c-8.134-.038-20.642 16.132-18.38 25.52-4.87-.518-11.297 13.254-14.814 19.217-.823 1.396 7.96 10.044 12.108 10.06 2.831.04 44.292-27.326 44.292-27.326 4.503-3.767 5.545-7.984 4.757-13.263C8.86-54.986 3.053-56.69.606-55.369c-.848-5.861-7.007-2.033-9.343-.465.342-5.64-4.356-9.435-9.201-9.457",
    transform: "matrix(-.9185 0 0 .94725 451.497 67.332)",
    id: "path85"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M43.972-92.72s1.323-.897 2.09-1.116c.823-.237 2.68-.253 2.68-.253s-10.905-6.996-16.23-9.658c-1.08-.54-3.624-.14-3.624-.14s-2.457-2.153-4.014-2.72c-1.174-.428-5.394-.13-5.394-.13 1.07 2.434 9.163 3.744 11.611 7.955.427 1.245 1.094 4.829 1.094 4.829s5.66-3.294 8.447-2.47c1.677.494 3.34 3.702 3.34 3.702",
    transform: "matrix(-.77771 0 0 .77771 484.561 88.155)",
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1,
      strokeWidth: 0.683903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M22.858-100.282c-5.642-.025-17.94 12.42-16.953 26.237.028.404.083.757.158 1.07a4 4 0 0 0-.38-.026C.47-73.025-9.512-60.145-9.551-53.861c-.04 6.284 1.014 11.022 6.227 11.093 2.831.039 49.388-30.042 49.388-30.042 4.503-3.767 5.546-7.984 4.757-13.263-1.837-6.945-6.188-4.413-8.634-3.092-.96-9.011-8.576-3.554-12.144-.249 1.014-7.92-2.34-10.846-7.185-10.868",
    transform: "matrix(-.77771 0 0 .77771 484.561 88.155)",
    id: "path87"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#bcddea",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M27.698-101.972c2.138.971-19.328-11.412-19.77-11.38-9.002.664-27.226 25.446-18.848 32.713 0 0 12.895 5.018 13.052 3.845 1.615-13.185 13.342-30.735 25.566-25.178",
    transform: "matrix(-.77771 0 0 .77771 484.561 88.155)",
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#accfe3",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m2.024-76.693-12.915-7.667c-.416-.247-1.605-.927-2.047-.968-7.972-.74-21.626 27.293-11.612 33.578 0 0 15.687 10.707 15.114 9.36-8.87-20.877 11.46-34.303 11.46-34.303",
    transform: "matrix(-.77771 0 0 .77771 484.561 88.155)",
    id: "path89"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#b1d1e6",
      fillOpacity: 1,
      strokeWidth: 0.691903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m483.338-266.95 30.897 17.868c1.809 1.046 1.103 4.143-.71 5.179l-18.359 10.49c-1.814 1.036-3.52 1.555-5.311.479l-29.49-17.72c-1.79-1.076-2.287-4.264-.48-5.311l18.141-10.506c1.808-1.047 3.503-1.525 5.312-.48",
    transform: "translate(-53.76 341.577)",
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d4d4d",
      fillOpacity: 1,
      strokeWidth: 0.337346,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m481.623-264.827 28.558 16.781c.878.516.538 2.02-.347 2.525l-8.95 5.115c-.885.505-1.717.757-2.59.233l-27.872-16.709c-.873-.523-1.115-2.079-.234-2.59l8.845-5.122c.881-.51 1.711-.75 2.59-.233",
    transform: "translate(-53.76 341.577)",
    id: "path91"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666",
      fillOpacity: 1,
      strokeWidth: 0.17865,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m477.256-250.94 8.81 5.1c.466.27.284 1.07-.184 1.337l-4.74 2.708c-.469.268-.909.401-1.372.124l-8.446-5.06c-.462-.278-.59-1.101-.123-1.372l4.684-2.712c.466-.27.906-.397 1.37-.124",
    transform: "translate(-53.76 341.577)",
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#23334d",
      fillOpacity: 1,
      strokeWidth: 0.691903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m482.705-267.142 30.914 18.97c1.78 1.092 3.615-.622 3.602-2.71l-.133-21.443c-.013-2.089.387-3.222-1.4-4.304l-31.2-18.876c-1.787-1.081-3.896-.36-3.882 1.728l.137 21.676c.013 2.09.181 3.867 1.962 4.96",
    transform: "translate(-53.76 341.577)",
    id: "path93"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#46bdd6",
      fillOpacity: 1,
      strokeWidth: 0.534415,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M483.91-268.098c3.506 1.562 30.628 18.38 30.628 18.38l.03-21.887c.002-1.614.306-2.501-1.082-3.324l-31.109-18.45s-.006 17.82.017 21.45c.01 1.614.14 2.987 1.516 3.831",
    transform: "translate(-53.76 341.577)",
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1cee0",
      fillOpacity: 1,
      strokeWidth: 0.534415,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M112.025-250.042c-.49-.002-10.978 6.095-22.497 12.875-12.026 6.813-25.922 14.827-33.202 19.528-2.868 1.852-2.501 6.394-2.501 6.394s-.343 26.31.552 38.511c.093 1.262 2.094 2.277 3.241 2.282.49.002 10.987-6.1 22.513-12.884 12.022-6.81 25.91-14.82 33.187-19.518 2.867-1.852 2.5-6.394 2.5-6.394s.344-26.31-.552-38.512c-.092-1.262-2.093-2.277-3.24-2.282",
    transform: "translate(-53.76 341.577)",
    id: "path95"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3db3d4",
      fillOpacity: 1,
      strokeWidth: 0.534415,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m59.408-177.106.023-37.699 52.67-30.565-.49 38.014z",
    transform: "translate(-53.76 341.577)",
    id: "path96"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1
    },
    id: "g97"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.683903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M-17.938-65.29c-8.134-.038-20.642 16.132-18.38 25.52-4.87-.518-11.297 13.254-14.814 19.217-.823 1.396 7.96 10.044 12.108 10.06 2.831.04 44.292-27.326 44.292-27.326 4.503-3.767 5.545-7.984 4.757-13.263C8.86-54.986 3.053-56.69.606-55.369c-.848-5.861-7.007-2.033-9.343-.465.342-5.64-4.356-9.435-9.201-9.457",
    transform: "matrix(-.35533 0 0 .36646 435.515 86.893)",
    id: "path97"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M43.972-92.72s1.323-.897 2.09-1.116c.823-.237 2.68-.253 2.68-.253s-10.905-6.996-16.23-9.658c-1.08-.54-3.624-.14-3.624-.14s-2.457-2.153-4.014-2.72c-1.174-.428-5.394-.13-5.394-.13 1.07 2.434 9.163 3.744 11.611 7.955.427 1.245 1.094 4.829 1.094 4.829s5.66-3.294 8.447-2.47c1.677.494 3.34 3.702 3.34 3.702",
    transform: "matrix(-.30087 0 0 .30087 448.306 94.949)",
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7d7ea",
      fillOpacity: 1,
      strokeWidth: 0.683903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M22.858-100.282c-5.642-.025-17.94 12.42-16.953 26.237.028.404.083.757.158 1.07a4 4 0 0 0-.38-.026C.47-73.025-9.512-60.145-9.551-53.861c-.04 6.284 1.014 11.022 6.227 11.093 2.831.039 49.388-30.042 49.388-30.042 4.503-3.767 5.546-7.984 4.757-13.263-1.837-6.945-6.188-4.413-8.634-3.092-.96-9.011-8.576-3.554-12.144-.249 1.014-7.92-2.34-10.846-7.185-10.868",
    transform: "matrix(-.30087 0 0 .30087 448.306 94.949)",
    id: "path99"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#bcddea",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M27.698-101.972c2.138.971-11.634-7.015-12.076-6.982-9.002.662-27.225 25.445-18.847 32.712 0 0 5.2.621 5.357-.552 1.615-13.185 13.342-30.735 25.566-25.178",
    transform: "matrix(-.30087 0 0 .30087 448.306 94.949)",
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#accfe3",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m2.024-76.693-4.56-3.38c-.39-.288-1.606-.927-2.047-.968-7.973-.74-21.627 27.293-11.613 33.578 0 0 7.333 6.42 6.76 5.072-8.87-20.876 11.46-34.302 11.46-34.302",
    transform: "matrix(-.30087 0 0 .30087 448.306 94.949)",
    id: "path101"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.683903,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M62.457-276.949c-5.642-.026-17.94 12.42-16.953 26.236.029.405.084.758.159 1.07a4 4 0 0 0-.381-.025c-5.213-.024-15.194 12.857-15.234 19.14s1.015 11.022 6.227 11.093c2.832.039 49.388-30.042 49.388-30.042 4.503-3.767 5.546-7.984 4.757-13.262-1.837-6.946-6.188-4.414-8.634-3.093-.96-9.01-8.576-3.554-12.144-.248 1.014-7.92-2.34-10.847-7.185-10.869m-.402 4.007c4.33.02 7.328 2.634 6.421 9.713 3.19-2.955 11.401-8.253 12.259-.2 2.187-1.18 6.074-3.443 7.717 2.764.704 4.718-.227 6.66-4.251 10.027 0 0-43.016 27.306-45.547 27.272-4.658-.064-5.6-2.472-5.565-8.088s9.205-16.63 13.864-16.61c.116.001.229.012.34.024a6 6 0 0 1-.141-.957c-.882-12.348 9.86-23.968 14.903-23.945",
    transform: "translate(4.206 249.607)scale(.4707)",
    id: "path102"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g103"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.243 10.918a.5.5 0 0 1 .23-.535.34.34 0 0 1 .304-.03l-.017-.047a.05.05 0 0 1 .023-.058c.02-.012.042-.005.05.016l.054.15a.05.05 0 0 1-.001.032.05.05 0 0 1-.022.026l-.144.083c-.02.012-.042.005-.05-.016a.05.05 0 0 1 .023-.058l.067-.04a.27.27 0 0 0-.26.016.4.4 0 0 0-.182.427.05.05 0 0 1-.028.057c-.02.009-.041-.001-.047-.023m.7-.356c.02-.01.041 0 .047.022a.5.5 0 0 1-.23.536.34.34 0 0 1-.304.03l.017.046a.05.05 0 0 1-.022.058c-.02.012-.042.005-.05-.016l-.054-.15a.05.05 0 0 1 0-.032.05.05 0 0 1 .022-.025l.144-.084c.02-.012.042-.005.05.016a.05.05 0 0 1-.023.058l-.067.04a.27.27 0 0 0 .26-.016.4.4 0 0 0 .182-.427.05.05 0 0 1 .028-.056",
    fill: "#0f1729",
    style: {
      fill: "#fff",
      strokeWidth: 0.040354
    },
    transform: "translate(-69.105 36.779)scale(8.81935)",
    id: "path103"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#274b78",
      fillOpacity: 1,
      strokeWidth: 0.801532,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m224.506-59.819 17.572 10.428 19.472-11.837-16.907-10.24z",
    transform: "translate(148.936 76.957)",
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#20366a",
      fillOpacity: 1,
      strokeWidth: 0.801532,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m224.434-8.712 17.485 10.575.16-51.254-17.573-10.428z",
    transform: "translate(148.936 76.957)",
    id: "path105"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#2c6193",
      fillOpacity: 1,
      strokeWidth: 0.801532,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M261.323-10.032 241.92 1.863l.16-51.254 19.471-11.837z",
    transform: "translate(148.936 76.957)",
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#327c97",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M243.97-40.549v5.098l15.459-9.167.07-5.355zm0-6.515v5.099l15.459-9.168.07-5.355zm0 13.03v5.098l15.459-9.167.07-5.356zm0 6.514v5.099l15.459-9.167.07-5.356zm0 6.516v5.098l15.459-9.168.07-5.355zm0 6.514v5.099l15.459-9.168.07-5.355zm0 6.515v5.098l15.459-9.167.07-5.355z",
    transform: "translate(148.936 76.957)",
    id: "path107"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#1b496b",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m238.682-38.33-.047 6.642-10.781-6.361-.024-6.9zm-.024 17.817.047 3.616-10.781-6.36-.117-3.345z",
    transform: "translate(148.936 76.957)",
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#243764",
      fillOpacity: 1,
      strokeWidth: 1.04041,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m254.862-62.522-9.261-5.781-14.391 9.03 8.933 5.659z",
    transform: "translate(148.936 76.957)",
    id: "path109"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#275d82",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m251.745-62.35-6.688-4.101-10.98 6.89 6.26 3.988z",
    transform: "translate(148.936 76.957)",
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#b2d1e3",
      fillOpacity: 1,
      strokeWidth: 0.871724,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M104.35-177.93a11.08 7.54 0 0 1-11.204 7.426 11.08 7.54 0 0 1-10.954-7.597 11.08 7.54 0 0 1 11.121-7.484 11.08 7.54 0 0 1 11.038 7.541",
    transform: "translate(-53.76 341.577)",
    id: "path111"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#263b56",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m98.991-194.172-2.115 11.828-9.326 5.49 1.687-11.718z",
    transform: "translate(-53.76 341.577)",
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#152149",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m89.33-188.619-1.78 11.766-2.514-1.654 1.128-8.297z",
    transform: "translate(-53.76 341.577)",
    id: "path113"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d9b949",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-216.826 446.154.066 19.05 2.514 1.587 19.116-12.038-.133-16.67-1.455.067-.463-.595.199-1.522-12.171 7.012-1.058-.926z",
    transform: "translate(233.522 -357.142)",
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#e6f1de",
      fillOpacity: 1,
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m-216.132 464.443 1.409.973-.26-16.757 18.315-10.46-.513-.66-18.89 10.372z",
    transform: "translate(233.522 -357.142)",
    id: "path115"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#346289",
      fillOpacity: 1,
      strokeWidth: 0.783005,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m299.554 156.83 20.66 12.382 20.593-12.325-21.397-12.39z",
    transform: "translate(188.598 -45.773)",
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283467",
      fillOpacity: 1,
      strokeWidth: 0.644937,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m299.295 183.484 20.946 11.992-.028-26.264-20.659-12.383z",
    transform: "translate(188.598 -45.773)",
    id: "path117"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d7294",
      fillOpacity: 1,
      strokeWidth: 0.523939,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m340.807 183.324-20.566 12.152-.028-26.264 20.594-12.325z",
    transform: "translate(188.598 -45.773)",
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a3062",
      fillOpacity: 1,
      strokeWidth: 0.792923,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M339.625 180.163v-5.174l-17.429 10.165v5.269zm-.065-13.554v-5.175l-17.428 9.802v5.632z",
    transform: "translate(188.598 -45.773)",
    id: "path119"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385f8a",
      fillOpacity: 1,
      strokeWidth: 0.792923,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "m300.993 175.555-.028-7.07 16.74 9.333.014 6.905zm0-8.133-.028-7.07 16.74 9.333.014 6.904zm0 16.267-.028-7.07 16.74 9.332.014 6.905z",
    transform: "translate(188.598 -45.773)",
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a3062",
      fillOpacity: 1,
      strokeWidth: 0.792923,
      strokeLinecap: "round",
      paintOrder: "stroke fill markers"
    },
    d: "M339.56 173.357v-5.174l-17.428 10.165v5.268z",
    transform: "translate(188.598 -45.773)",
    id: "path121"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#325e85",
      fillOpacity: 1,
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "M525.006-174.759v7.297l18.054-10.477-.187-7.39z",
    transform: "translate(-53.76 341.577)",
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#34537c",
      fillOpacity: 1,
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "M525.193-165.03v7.016l17.68-10.57v-7.11z",
    transform: "translate(-53.76 341.577)",
    id: "path123"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#2d3b68",
      fillOpacity: 1,
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "M524.445-167.602v-6.782L498.813-190.1v7.577z",
    transform: "translate(-53.76 341.577)",
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#2e4b7b",
      fillOpacity: 1,
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "M524.445-165.03v7.11l-26.1-15.061-.093-8.139z",
    transform: "translate(-53.76 341.577)",
    id: "path125"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#32567a",
      fillOpacity: 1,
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "m498.72-190.661 18.335-9.822 25.818 15.154-17.867 10.57z",
    transform: "translate(-53.76 341.577)",
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50869f",
      fillOpacity: 1,
      strokeWidth: 0.419503,
      strokeLinecap: "round",
      strokeDasharray: "none",
      paintOrder: "stroke fill markers"
    },
    d: "M523.427-164.158v4.26l-23.976-13.92-.056-4.877zm.336-9.357v4.26l-23.975-13.92-.056-4.878z",
    transform: "translate(-53.76 341.577)",
    id: "path127"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendSystem);
export default __webpack_public_path__ + "static/media/backend-system.3dd8e4f074edbe49c865b0c96714cf6d.svg";
export { ForwardRef as ReactComponent };